<div class="selected-cluster-container">
  <div class="cluster-dialog" *ngIf="_selectedCluster">
    <h3>{{_selectedCluster.item}}</h3>
    <div class="lijst-row"
         *ngFor="let competentie of _selectedCluster.competentiesLeft; let i = index">
      <div class="lijst-col">
        <p>{{competentie.naam}}</p>
        <p class="bar-percentage">
          <span *ngIf="competentie.label && competentie.gewicht > 0; else nvtLeft">{{'competence.niveau' | content}}
            <strong>{{competentie.label}}</strong></span>
          <ng-template #nvtLeft>{{'competence.nvt' | content}}</ng-template>
        </p>
        <mat-progress-bar class="function-compare-left" [value]="competentie.gewicht">
        </mat-progress-bar>
      </div>
      <div class="lijst-col" *ngIf="_selectedCluster.competentiesRight">
        <p>{{_selectedCluster.competentiesRight[i].naam}}</p>
        <p class="bar-percentage">
          <span
            *ngIf="_selectedCluster.competentiesRight[i].label && _selectedCluster.competentiesRight[i].gewicht > 0; else nvtRight">{{'competence.niveau' | content}}
            <strong>{{_selectedCluster.competentiesRight[i].label}}</strong></span>
          <ng-template #nvtRight>{{'competence.nvt' | content}}</ng-template>
        </p>
        <mat-progress-bar class="function-compare-right" [value]="_selectedCluster.competentiesRight[i].gewicht">
        </mat-progress-bar>
      </div>
    </div>
  </div>
  <div class="compare__cluster-dialog-empty" *ngIf="!_selectedCluster" [innerHTML]="descriptionContent"></div>
</div>
